
import * as axios from "__axios";


export default function removeServerFile(file) {
    this.in_progress = true;
    this.error = null;
    let formData = new FormData();
    formData.append("path", this.getPath());
    formData.append("file", file);
    axios
        .post("/vuetifiles-remove.json", formData)
        .then((response) => {
            if (response.status === 200) this.updateFilesWith(response.data);
            this.in_progress = false;
        })
        .catch((error) => {
            console.log(error);
            this.error = error;
            this.in_progress = false;
        });
}
